export default __webpack_public_path__ + "static/media/mask-group-398@2x.52a2a922.png";